import { TtmsAppConfig } from "@tt/ttms-react-core";

const baseTtmsAppConfig: TtmsAppConfig = {
  appTitle: "SafebookL",
  auth: {
    authority: "https://devauth.thyteknik.com.tr/",
    clientId: "SafebookLocal",
    scope: "safebook",
  },
  api: {
    baseUrl: "https://localhost:5001/api",
  },
  menu: [
    { text: "Dashboard", icon: "home", path: "/anasayfa" },
    { text: "Create", icon: "video_call", path: "/videos/create" },
    { text: "Search", icon: "search", path: "/videos" },
    {
      text: "Settings",
      icon: "settings",
      permissions: ["safebook.admin"],
      children: [
        { text: "Video List", icon: "featured_play_list", path: "/video-list" },
        { text: "Category List", icon: "art_track", path: "/categorys" },
        { text: "Comment List", icon: "comment", path: "/comments" },
      ],
    },
    {
      text: "Reports",
      icon: "insert_chart",
      permissions: ["safebook.admin"],
      children: [
        {
          text: "Watched Report",
          icon: "flag",
          path: "/videoreports",
        },
        {
          text: "Unit Report",
          icon: "flag",
          path: "/videounitreports",
        },
      ],
    },
  ],
};

export const local: TtmsAppConfig = {
  ...baseTtmsAppConfig,
  appTitle: "SafebookL",
  auth: {
    authority: "https://devauth.thyteknik.com.tr",
    clientId: "SafebookLocal",
    scope: "safebook",
  },
  api: {
    baseUrl: "https://localhost:5001/api",
  },
};

export const development: TtmsAppConfig = {
  ...baseTtmsAppConfig,
  appTitle: "SafebookD",
  auth: {
    authority: "https://devauth.thyteknik.com.tr",
    clientId: "SafebookDev",
    scope: "safebook",
  },
  api: {
    baseUrl: "https://devapi.turkishtechnic.com/safebook/api",
  },
};

export const test: TtmsAppConfig = {
  ...baseTtmsAppConfig,
  appTitle: "SafebookT",
  auth: {
    authority: "https://testauth.thyteknik.com.tr",
    clientId: "SafebookTest",
    scope: "safebook",
  },
  api: {
    baseUrl: "https://testapi.turkishtechnic.com/safebook/api",
  },
};

export const production: TtmsAppConfig = {
  ...baseTtmsAppConfig,
  appTitle: "Safebook",
  auth: {
    authority: "https://auth.thyteknik.com.tr",
    clientId: "Safebook",
    scope: "safebook",
  },
  api: {
    baseUrl: "https://api.turkishtechnic.com/safebook/api",
  },
};
